import { DirectiveBinding,VNode,ComponentPublicInstance } from '@vue/runtime-core'
type settings = {
  ids: string
  vue:ComponentPublicInstance,
  url: string, 
  standard: string, 
  extraHead: string, 
  extraCss: String, 
  previewTitle: String 
  zIndex: number,
  previewPrintBtnLabel: string
  popTitle: string
  preview: boolean
  asyncUrl: Function,
  previewBeforeOpenCallback:Function,
  previewOpenCallback:Function,
  openCallback:Function,
  closeCallback:Function,
  beforeOpenCallback:Function
}
type el = HTMLElement&{attachEvent(type: string, listener: EventListenerOrEventListenerObject): void}&Record<string, unknown>
export default class {
  constructor(option:settings) {
    let that: any = this;
    that.standards = {
      strict: 'strict',
      loose: 'loose',
      html5: 'html5'
    };
    that.previewBody = null;
    that.close = null;
    that.previewBodyUtilPrintBtn = null;
    that.selectArray = []; // 存储select的
    that.counter = 0;
    that.settings = {
      standard: that.standards.html5,
    };
    
    Object.assign(that.settings, option);
    that.init();
  }
  init () {
    let that: any = this;
    that.counter++;
    that.settings.id = `printArea_${that.counter}`;
    let url = ''
    if (that.settings.url && !that.settings.asyncUrl) {
      url = that.settings.url
    }
    let _this = that
    // 如果是异步的
    if (that.settings.asyncUrl) {

      _this.settings.asyncUrl(function (url:string) {
        let PrintAreaWindow = _this.getPrintWindow(url); // 创建iframe
        if (_this.settings.preview) {
          // 打开预览弹窗
          _this.previewIfrmaeLoad()
        } else {
          // 直接打印
          _this.print(PrintAreaWindow);
        }
      },_this.settings.vue)
      return

    }
    let PrintAreaWindow = that.getPrintWindow(url); // 创建iframe

    if (!that.settings.url) {
      that.write(PrintAreaWindow.doc); // 写入内容
    }

    if (that.settings.preview) {
      // 打开预览弹窗
      that.previewIfrmaeLoad()
    } else {
      // 直接打印
      that.print(PrintAreaWindow);
    }
  }
  addEvent (element:el, type:string, callback:EventListenerOrEventListenerObject) {
    if (element.addEventListener) {
      element.addEventListener(type, callback, false);
    } else if (element.attachEvent) {
      element.attachEvent('on' + type, callback);
    } else {
      element['on' + type] = callback;
    }
  }
  previewIfrmaeLoad () {
    let that: any = this;
    let box = document.getElementById('vue-pirnt-nb-previewBox')

    if (box) {
      let _this = that
      let iframe:any = box.querySelector('iframe')
      that.settings.previewBeforeOpenCallback()
      that.addEvent(iframe, 'load', function () {
        _this.previewBoxShow()
        _this.removeCanvasImg()
        _this.settings.previewOpenCallback()
      })

      that.addEvent(box.querySelector('.previewBodyUtilPrintBtn'), 'click', function () {
        _this.settings.beforeOpenCallback()
        _this.settings.openCallback();
        iframe.contentWindow.print();
        _this.settings.closeCallback()
      })
    }
  }
  // 删除所有canva转换的图片
  removeCanvasImg () {
    let _this:any = this
    try {
      if (_this.elsdom) {
        // 删除canva转变图片的dom节点
        let canvasList = _this.elsdom.querySelectorAll('.canvasImg')
        for (let i = 0; i < canvasList.length; i++) {
          canvasList[i].remove()
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
  print (ifrmae:{f:HTMLIFrameElement}) {
    var _this:any = this;
    let iframe = document.getElementById(_this.settings.id) || ifrmae.f;
    let iframeWin = (document as any).getElementById(_this.settings.id).contentWindow || ifrmae.f.contentWindow;
    var _loaded = function () {

      iframeWin.focus();
      _this.settings.openCallback();
      iframeWin.print();
      iframe.remove() // 删除ifrmae元素
      _this.settings.closeCallback()
      _this.removeCanvasImg()
    }
    _this.settings.beforeOpenCallback()
    _this.addEvent(iframe, 'load', function () {
      _loaded()
    })

  }
  write (PADocument:Document) {
    let that: any = this;
    PADocument.open();
    PADocument.write(`${that.docType()}<html>${that.getHead()}${that.getBody()}</html>`);
    PADocument.close();

  }
  docType () {
    let that: any = this;
    if (that.settings.standard === that.standards.html5) {
      return '<!DOCTYPE html>';
    }
    var transitional = that.settings.standard === that.standards.loose ? ' Transitional' : '';
    var dtd = that.settings.standard === that.standards.loose ? 'loose' : 'strict';

    return `<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01${transitional}//EN" "http://www.w3.org/TR/html4/${dtd}.dtd">`;
  }
  getHead () {
    let that: any = this;
    let extraHead = '';
    let links = '';
    let style = '';
    if (that.settings.extraHead) {
      that.settings.extraHead.replace(/([^,]+)/g, (m:string) => {
        extraHead += m;
      });
    }
    // 复制所有link标签
    [].forEach.call(document.querySelectorAll('link'), function (item:HTMLLinkElement) {
      if (item.href.indexOf('.css') >= 0) {
        links += `<link type="text/css" rel="stylesheet" href="${item.href}" >`;
      }
    });
    // 循环获取style标签的样式
    let domStyle = document.styleSheets;
    if (domStyle && domStyle.length > 0) {
      for (let i = 0; i < domStyle.length; i++) {
        try {
          if (domStyle[i].cssRules || domStyle[i].rules) {
            let rules = domStyle[i].cssRules || domStyle[i].rules;
            for (let b = 0; b < rules.length; b++) {
              style += rules[b].cssText;
            }
          }
        } catch (e) {
          console.log(domStyle[i].href + e);
        }
      }
    }

    if (that.settings.extraCss) {
      that.settings.extraCss.replace(/([^,\s]+)/g, (m:string) => {
        links += `<link type="text/css" rel="stylesheet" href="${m}">`;
      });

    }

    return `<head><title>${that.settings.popTitle}</title>${extraHead}${links}<style type="text/css">${style}</style></head>`;
  }

  getBody () {
    let that: any = this;
    let ids = that.settings.ids;
    ids = ids.replace(new RegExp("#", "g"), '');
    that.elsdom = that.beforeHanler(document.getElementById(ids));
    let ele = that.getFormData(that.elsdom);
    let htm = ele.outerHTML;
    return '<body>' + htm + '</body>';
  }
  // 处理canva转成图片
  beforeHanler (elsdom:Document) {
    let canvasList = elsdom.querySelectorAll('canvas');
    // canvas转换png图片
    for (let i = 0; i < canvasList.length; i++) {
      if (!canvasList[i].style.display) {
        let _parent = canvasList[i].parentNode;
        let _canvasUrl = canvasList[i].toDataURL('image/png');
        let _img = new Image();
        _img.className = 'canvasImg';
        _img.style.display = 'none';
        _img.src = _canvasUrl;
        (_parent as Node).appendChild(_img)
      }
    }
    return elsdom
  }
  // 根据type去处理form表单
  getFormData (ele:Element) {
    let copy =( ele.cloneNode(true) as Element);
    let copiedInputs = copy.querySelectorAll('input,select,textarea');
    let canvasImgList = copy.querySelectorAll('.canvasImg,canvas');
    let selectCount = -1;
    // 处理所有canvas
    for (let i = 0; i < canvasImgList.length; i++) {
      let _parent = (canvasImgList[i].parentNode as Node)
      let item = canvasImgList[i]
      // 删除克隆后的canvas节点
      if (item.tagName.toLowerCase() === 'canvas') {
        _parent.removeChild(item)
      } else {
        (item as HTMLElement).style.display = 'block'
      }
    }
    // 处理所有输入框
    for (let i = 0; i < copiedInputs.length; i++) {
      let item = copiedInputs[i];
      let typeInput = item.getAttribute('type');
      let copiedInput = (copiedInputs[i] as HTMLInputElement);
      // 获取select标签
      if (!typeInput) {
        typeInput = item.tagName === 'SELECT' ? 'select' : item.tagName === 'TEXTAREA' ? 'textarea' : '';
      }
      // 处理input框
      if (item.tagName === 'INPUT') {
        
        // 除了单选框 多选框比较特别
        if (typeInput === 'radio' || typeInput === 'checkbox') {
          if ((item as HTMLInputElement).checked) {
            copiedInput.setAttribute('checked', (item as HTMLInputElement).checked.toString());
          }

        } else {
          copiedInput.value = (item as HTMLInputElement).value;
          copiedInput.setAttribute('value', (item as HTMLInputElement).value);
        }
        // 处理select
      } else if (typeInput === 'select') {

        selectCount++;
        for (let b = 0; b < ele.querySelectorAll('select').length; b++) {
          let select =( ele.querySelectorAll('select')[b] as Element); // 获取原始层每一个select
          !select.getAttribute('newbs') && select.setAttribute('newbs', `${b}`) // 添加标识
          if (select.getAttribute('newbs') == `${selectCount}`) {
            let opSelectedIndex = ele.querySelectorAll('select')[selectCount].selectedIndex;
            (item as any).options[opSelectedIndex].setAttribute('selected', true);

          }
        }
        // 处理textarea
      } else {
        copiedInput.innerHTML = (item as HTMLTextAreaElement).value;
        copiedInput.setAttribute('html', (item as HTMLTextAreaElement).value);
      }
    }

    return copy;
  }
  getPrintWindow (url:string) {
    let that: any = this;
    var f = that.Iframe(url);
    return {
      f: f,
      win: f.contentWindow || f,
      doc: f.doc
    };
  }
  previewBoxShow () {
    let box = document.getElementById('vue-pirnt-nb-previewBox')
    if (box) {
      (document as any).querySelector('html').setAttribute('style', 'overflow: hidden')
      box.style.display = 'block'
    }
  }
  previewBoxHide () {
    let box = document.getElementById('vue-pirnt-nb-previewBox') 
    if (box) {
      (document as any).querySelector('html').setAttribute('style', 'overflow: visible;')
      box.querySelector('iframe') && (box.querySelector('iframe') as HTMLIFrameElement).remove()
      box.style.display = 'none'
    }
  }
  previewBox () {
    let that: any = this;
    let box = document.getElementById('vue-pirnt-nb-previewBox')
    let previewBodyClass = 'previewBody'
    if (box) {
      box.querySelector('iframe') && (box.querySelector('iframe') as HTMLIFrameElement).remove()
      return {
        close: box.querySelector('.previewClose'),
        previewBody: box.querySelector(`.${previewBodyClass}`)
      }
    }
    let previewContent = document.createElement('div');
    previewContent.setAttribute('id', "vue-pirnt-nb-previewBox")
    previewContent.setAttribute('style', 'position: fixed;top: 0px;left: 0px;width: 100%;height: 100%;background: white;display:none')
    previewContent.style.zIndex = that.settings.zIndex
    // 打印预览弹窗的header
    let previewHeader = document.createElement('div');
    previewHeader.setAttribute('class', "previewHeader")
    previewHeader.setAttribute('style', "padding: 5px 20px;")
    previewHeader.innerHTML = that.settings.previewTitle
    previewContent.appendChild(previewHeader)
    // close关闭按钮
    that.close = document.createElement('div');
    let close = that.close
    close.setAttribute('class', "previewClose")
    close.setAttribute('style', "position: absolute;top: 5px;right: 20px;width: 25px;height: 20px;cursor: pointer;")
    let closeBefore = document.createElement('div');
    let closeAfter = document.createElement('div');
    closeBefore.setAttribute('class', "closeBefore")
    closeBefore.setAttribute('style', "position: absolute;width: 3px;height: 100%;background: #040404;transform: rotate(45deg); top: 0px;left: 50%;")
    closeAfter.setAttribute('class', "closeAfter")
    closeAfter.setAttribute('style', "position: absolute;width: 3px;height: 100%;background: #040404;transform: rotate(-45deg); top: 0px;left: 50%;")
    close.appendChild(closeBefore)
    close.appendChild(closeAfter)
    previewHeader.appendChild(close)

    // 打印预览弹窗的body
    that.previewBody = document.createElement('div');
    let previewBody = that.previewBody
    previewBody.setAttribute('class', previewBodyClass)
    previewBody.setAttribute('style', "display: flex;flex-direction: column; height: 100%;")
    previewContent.appendChild(previewBody)
    // 打印预览弹窗的body的工具栏
    let previewBodyUtil = document.createElement('div');
    previewBodyUtil.setAttribute('class', "previewBodyUtil")
    previewBodyUtil.setAttribute('style', "height: 32px;background: #474747;position: relative;")
    previewBody.appendChild(previewBodyUtil)
    // 打印的按钮
    that.previewBodyUtilPrintBtn = document.createElement('div');
    let previewBodyUtilPrintBtn = that.previewBodyUtilPrintBtn
    previewBodyUtilPrintBtn.setAttribute('class', 'previewBodyUtilPrintBtn')
    previewBodyUtilPrintBtn.innerHTML = that.settings.previewPrintBtnLabel
    previewBodyUtilPrintBtn.setAttribute('style', 'position: absolute;padding: 2px 10px;margin-top: 3px;left: 24px;font-size: 14px;color: white;cursor: pointer;background-color: rgba(0,0,0,.12);background-image: linear-gradient(hsla(0,0%,100%,.05),hsla(0,0%,100%,0));background-clip: padding-box;border: 1px solid rgba(0,0,0,.35);border-color: rgba(0,0,0,.32) rgba(0,0,0,.38) rgba(0,0,0,.42);box-shadow: inset 0 1px 0 hsla(0,0%,100%,.05), inset 0 0 1px hsla(0,0%,100%,.15), 0 1px 0 hsla(0,0%,100%,.05);')
    previewBodyUtil.appendChild(previewBodyUtilPrintBtn)

    // 添加整个预览到body
    document.body.appendChild(previewContent);

    return {
      close: that.close,
      previewBody: that.previewBody
    }
  }
  iframeBox (frameId:string, url:string) {
    let iframe:HTMLIFrameElement = document.createElement('iframe');
    iframe.style.border = '0px';
    iframe.style.position = 'absolute';
    iframe.style.width = '0px';
    iframe.style.height = '0px';
    iframe.style.right = '0px';
    iframe.style.top = '0px';
    iframe.setAttribute('id', frameId);
    iframe.setAttribute('src', url);

    return iframe
  }
  Iframe (url:string|number) {
    let that: any = this;
    let frameId = that.settings.id;
    // 局部打印 用当前的时间做ifrmae的url
    url = !url ? new Date().getTime() : url
    let _this = that

    let iframe = that.iframeBox(frameId, url)

    // let that = that
    try {
      // 直接打印 不预览
      if (!that.settings.preview) {
        document.body.appendChild(iframe);

      } else {
        iframe.setAttribute('style', 'border: 0px;flex: 1;')
        // 预览打印
        let previewBox = that.previewBox()
        let previewBody = previewBox.previewBody
        let close = previewBox.close
        // 添加ifrmae到预览弹窗
        previewBody.appendChild(iframe);
        that.addEvent(close, 'click', function () {
          _this.previewBoxHide()
        })
      }

      iframe.doc = null;
      iframe.doc = iframe.contentDocument ? iframe.contentDocument : (iframe.contentWindow ? iframe.contentWindow.document : iframe.document);
    } catch (e) {
      throw new Error(e + '. iframes may not be supported in that browser.');
    }
    if (iframe.doc == null) {
      throw new Error('Cannot find document.');
    }
    return iframe;
  }
}